import type { AddressingCountryCode, AddressingCountryMetadata, AddressingLocaleKey } from './types';

export async function loadAddressingCountryMetadata(): Promise<Record<AddressingCountryCode, AddressingCountryMetadata>> {
    const module = await import('./country-metadata');
    return module.default;
}

export const countryNamesLoaders: Record<AddressingLocaleKey, () => Promise<Record<AddressingCountryCode, string>>> = {
    'en': async () => {
        const module = await import('./en-UK/country-names');
        return module.default;
    },
    'nl': async () => {
        const module = await import('./nl-NL/country-names');
        return module.default;
    },
    'fr': async () => {
        const module = await import('./fr-FR/country-names');
        return module.default;
    },
    'de': async () => {
        const module = await import('./de-DE/country-names');
        return module.default;
    },
    'es': async () => {
        const module = await import('./es-ES/country-names');
        return module.default;
    },
    'it': async () => {
        const module = await import('./it-IT/country-names');
        return module.default;
    },
}